import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../../../components/common/PrimaryButton";
import styles from "./styles.module.scss";
import TextArea from "../../../../components/forms/textarea";
import MilestoneHeader from "../milestoneHeader";
import { useEffect, useState } from "react";
import ContractAlert from "../alert";
import DatePicker from "../../../../components/common/DatePicker";
import OutlinedButton from "../../../../components/common/OutlinedButton";
import ConfirmationModal from "../confirmationModal";
import { isNoOp } from "../../../../setup/util/isNoOp";
import { ReactComponent as SaveLater } from "../../../../assets/images/svg/saveLater.svg";

interface IStepFiveProps {
  handleNext: () => void;
  handlePrev: () => void;
  handleSaveDraft: (isPreviewMilestone: boolean) => void;
  currentStep: number;
  loading: boolean;
  isEditCreatedMilestone?: boolean;
}

const StepFive = ({
  handleNext,
  handlePrev,
  currentStep,
  handleSaveDraft,
  loading,
  isEditCreatedMilestone,
}: IStepFiveProps) => {
  const {
    control,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();
  const [isAlertOpen, setIsAlertOpen] = useState(true);
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const currentMilestoneIndex = watch("currentMilestoneIndex") || 0;

  const isValid =
    !!watch(`milestones.${currentMilestoneIndex}.deadline`) &&
    !errors?.milestones?.[currentMilestoneIndex]?.deadline;

  useEffect(() => {
    trigger([`milestones.${currentMilestoneIndex}.deadline`]);
  }, [currentMilestoneIndex, trigger]);

  return (
    <div className={styles.stepFive}>
      <MilestoneHeader
        complexContractTitle={watch("title")}
        currentStep={currentStep}
      />

      {isAlertOpen && (
        <ContractAlert
          iconSrc="/assets/images/svg/warning.svg"
          ctaLabel="X"
          variant="warning"
          onCtaClick={() => setIsAlertOpen(false)}
          title={t("lbl_alert_fill_data_carefully")}
        />
      )}

      <Controller
        name={`milestones.${currentMilestoneIndex}.deadline`}
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <div className={styles.dateWrapper}>
            <DatePicker
              value={field?.value ? new Date(field?.value) : null}
              placeholder={t("lbl_deadline")}
              label={t("lbl_deadline")}
              handleChange={(date) => {
                field?.onChange(date?.toString());
              }}
              minDate={new Date()}
            />

            {errors?.milestones?.[currentMilestoneIndex]?.deadline && (
              <p className={styles.errorText}>
                {errors?.milestones?.[
                  currentMilestoneIndex
                ]?.deadline?.message?.toString()}
              </p>
            )}
          </div>
        )}
      />
      <Controller
        name={`milestones.${currentMilestoneIndex}.milestoneReleaseTerms`}
        control={control}
        defaultValue={""}
        rules={{ required: false, max: 2000, min: 10 }}
        render={({ field }) => (
          <div className={styles.fullWidth}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}>
              <h4 className={styles.sectionTitle}>{t("lbl_release_terms")}</h4>
              {/*  <OutlinedButton
                style={{
                  width: "129px",
                  height: "40px",
                  borderColor: "#E2E5EE",
                  color: "black",
                  whiteSpace: "nowrap",
                  fontSize: "12px",
                  marginBottom: "12px",
                }}
                onClick={() =>
                  field?.onChange(`١. يتم صرف الدفعة بعد قيام مكتب المحاماة بإنجاز المرحلة المتفق عليها من التفاوض أو المتابعة القانونية.
٢. يشترط تزويد العميل بتقرير مكتوب يوضح الإجراءات التي تمت والخطوات المتخذة لتسوية النزاع.
٣. لا يتم صرف الدفعة إلا بعد اعتماد العميل استلام الخدمة أو توقيعه بالموافقة على ما تم إنجازه.
٤. في حال الوصول إلى تسوية ودية أو صدور قرار/حكم ابتدائي يخدم مصلحة العميل، تعتبر المرحلة مكتملة ويستحق صرف الدفعة.
                `)
                }>
                {t("lbl_add_default_value")}
              </OutlinedButton>*/}
            </div>
            <TextArea
              {...field}
              containerClassName={styles.textAreaContainer}
              maxCharacters={2000}
              minInputHeight="127px"
              maxInputHeight="200px"
              placeholder={t("lbl_release_terms_placeholder")}
              handleChange={field?.onChange}
              errorMessage={errors?.milestones?.[
                currentMilestoneIndex
              ]?.milestoneReleaseTerms?.message?.toString()}
            />
          </div>
        )}
      />
      <Controller
        name={`milestones.${currentMilestoneIndex}.milestoneCancelTerms`}
        control={control}
        defaultValue={""}
        rules={{ required: false, max: 2000, min: 10 }}
        render={({ field }) => (
          <div className={styles.fullWidth}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}>
              <h4 className={styles.sectionTitle}>{t("lbl_cancel_terms")}</h4>
              {/* <OutlinedButton
                style={{
                  width: "129px",
                  height: "40px",
                  borderColor: "#E2E5EE",
                  color: "black",
                  whiteSpace: "nowrap",
                  fontSize: "12px",
                  marginBottom: "12px",
                }}
                onClick={() =>
                  field?.onChange(`١. يحق للعميل الامتناع عن صرف الدفعة إذا لم يقم مكتب المحاماة بتنفيذ الأعمال المتفق عليها أو تأخر بشكل غير مبرر.
٢. في حال انسحب مكتب المحاماة من متابعة النزاع قبل إنجاز المرحلة، يتم إلغاء استحقاق الدفعة.
٣. إذا ثبت تقصير أو إهمال في تقديم الخدمة أو عدم الالتزام بالجدول الزمني المتفق عليه، يحق للعميل إلغاء الدفعة.
٤. يحق للعميل إلغاء الدفعة إذا تم إنهاء الاتفاق قبل بدء تنفيذ المرحلة أو قبل تقديم أي عمل فعلي من المكتب.
                `)
                }>
                {t("lbl_add_default_value")}
              </OutlinedButton> */}
            </div>
            <TextArea
              {...field}
              containerClassName={styles.textAreaContainer}
              maxCharacters={2000}
              minInputHeight="127px"
              maxInputHeight="200px"
              placeholder={t("lbl_cancel_terms_placeholder")}
              handleChange={field?.onChange}
              errorMessage={errors?.milestones?.[
                currentMilestoneIndex
              ]?.milestoneCancelTerms?.message?.toString()}
            />
          </div>
        )}
      />

      <div className={styles.footer}>
        <PrimaryButton
          disabled={!isValid || loading}
          onClick={handleNext}
          style={{
            background: isValid && !loading ? "#0D44AD" : "#EEF0F5",
            width: "200px",
          }}>
          {!isEditCreatedMilestone
            ? t("lbl_publish_milestone_contract")
            : t("lbl_save_milestone_contract")}
        </PrimaryButton>
        {!isNoOp(handleSaveDraft) && (
          <>
            <OutlinedButton
              onClick={() => setModalOpen(true)}
              style={{
                width: "180px",
                color: "#0D44AD",
                background: "#F3F6FC",
                border: "none",
              }}>
              {t("lbl_save_and_continue_later")}
            </OutlinedButton>
            <OutlinedButton
              onClick={() => handleSaveDraft(true)}
              style={{
                width: "137px",
                color: "#10131D",
                background: "#FFFFFF",
                border: "none",
                padding: "0px",
                textDecoration: "underline",
              }}>
              {t("lbl_preview_milestone_contract")}
            </OutlinedButton>
          </>
        )}
        <OutlinedButton
          onClick={handlePrev}
          style={{
            color: "black",
            borderColor: "#E2E5EE",
            width: "170px",
            marginRight: "auto",
          }}>
          <img
            src="/assets/images/svg/rightArrow.svg"
            alt="edit"
            style={{ width: "16px", height: "16px", marginLeft: "8px" }}
          />{" "}
          {t("lbl_prev")}
        </OutlinedButton>
      </div>
      <ConfirmationModal
        handleClose={() => {
          setModalOpen(false);
        }}
        handleConfirm={async () => {
          await handleSaveDraft(false);
          setModalOpen(false);
        }}
        confirmText="حفظ كمسوده"
        cancelText="الرجوع"
        modalOpen={modalOpen}
        title={"حفظ البيانات والإكمال لاحقاً"}
        description={"سيتم حفظ المعامله كمسوده ويمكنك إكمال المعاملة لاحقًا"}
        icon={<SaveLater />}
        containerStyle={styles.modalContainer}
      />
    </div>
  );
};

export default StepFive;
